<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-primary">
        <h4 class="card-title">Merchant Guidelines</h4>
        <p class="card-category">
          Shown on your shop page behind a "Merchant Guidelines" link — ordering, packing,
          live arrival, collection, whatever a shopper should read before buying.
          Leave it empty and no link appears.
        </p>
      </div>
      <div class="card-body">
        @if (loading()) {
          <p class="text-muted">Loading…</p>
        } @else {
          <angular-editor
            [formControl]="contentControl"
            [placeholder]="'Write your merchant guidelines here…'"
            [config]="editorConfig">
          </angular-editor>

          @if (updatedAt()) {
            <p class="text-muted mt-2" style="font-size: 12px;">
              Last updated {{ updatedAt() | date: 'medium' }}
            </p>
          }

          <div class="mt-3">
            <button mat-raised-button color="primary" (click)="save()" [disabled]="saving() || !loaded()">
              {{ saving() ? 'Saving…' : 'Save' }}
            </button>
          </div>

          @if (success()) {
            <div class="alert alert-success mt-3">{{ success() }}</div>
          }
          @if (error()) {
            <div class="alert alert-danger mt-3">{{ error() }}</div>
          }
        }
      </div>
    </div>
  </div>
</div>
